An array of suggested job categories for the provided partial `PositionProfile` in decreasing order of relevance.

A maximum of 10 job categories can be recommended.

This query accepts browser tokens that include the `query:ontologies` scope or `query:enhanced-job-posting` scope.
